<template>
  <div class="container mt-5">
    <Loading v-if="!team"/>

    <div v-if="team">
      <div class="row mb-5">
        <div class="col-5">
          <h3>{{team.name}}</h3>
        </div>
        <div class="col-7 text-right">
          <router-link :to="{ name: 'PlayerAdd', params: { team: team._id, name: team.name }}">
            <button type="button" class="btn btn-primary mr-3">Add player(s)</button>
          </router-link>
          <router-link :to="{ name: 'TeamEdit', params: { id: team._id }}">
            <button type="button" class="btn btn-primary mr-3">Edit Team</button>
          </router-link>
          <button type="button" class="btn btn-danger mr-3" v-b-modal.delete-team-modal>Delete Team</button>
          <button type="button" class="btn btn-secondary" @click="$router.go(-1)">Back</button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <input type="text" name="search" class="form-control" placeholder="Search..." v-model="searchText">
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <table class="table">
            <thead>
              <tr>
                <th>Sport</th>
                <th>Number</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Usual Name</th>
                <th>Position</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="player of players" :key="player._id">
                <td>{{player.sport.name}}</td>
                <td>{{player.number}}</td>
                <td>{{player.first_name}}</td>
                <td>{{player.last_name}}</td>
                <td v-if="player.usual_name">{{player.usual_name}}</td>
                <td v-else class="text-muted">None</td>
                <td>{{player.position.name}}</td>
                <td>
                  <button class="btn btn-warning btn-xs btn-block" v-b-modal.edit-player-modal @click="preparePlayerEdition(player)">Edit</button>
                </td>
                <td>
                  <button class="btn btn-danger btn-xs btn-block" v-b-modal.delete-player-modal @click="playerDeletion = player">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal id="edit-player-modal" title="Edit Player" :no-fade="true" @ok="editPlayer" v-if="team && sports && positions">
      <div class="my" v-if="playerEdition">
        <form>
          <div class="form-group">
            <label for="first_name">First Name</label>
            <input type="text" class="form-control" name="first_name" v-model="playerEdition.first_name" placeholder="">
          </div>
          <div class="form-group">
            <label for="first_name">Last Name</label>
            <input type="text" class="form-control" name="last_name" v-model="playerEdition.last_name" placeholder="">
          </div>
          <div class="form-group">
            <label for="first_name">Usual Name</label>
            <input type="text" class="form-control" name="usual_name" v-model="playerEdition.usual_name" placeholder="">
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="number">Number</label>
                <input type="number" name="number" class="form-control" v-model="playerEdition.number" placeholder="">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="previous_yellow_cards">Previous Yellow Cards</label>
                <input type="number" name="previous_yellow_cards" class="form-control" v-model="playerEdition.previous_yellow_cards" placeholder="">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="number">Sport</label>
                <select class="form-control" name="sport" v-model="playerEdition.sport">
                  <option v-for="sport of sports" :key="sport._id" :value="sport._id">{{ sport.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="number">Position</label>
                <select class="form-control" name="position" v-model="playerEdition.position">
                  <option v-for="position of positions" :key="position._id" :value="position._id">{{ position.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal id="delete-player-modal" title="Warning: Player Deletion" :no-fade="true" v-if="team && sports && positions" @ok="deletePlayer">
      <div>
        <p v-if="playerDeletion">
          This will delete the player "{{playerDeletion.first_name}} {{playerDeletion.last_name}} {{playerDeletion.usual_name}}" <b>permanently</b>.
        </p>
      </div>
    </b-modal>

    <b-modal id="delete-team-modal" title="Warning: Team Deletion" :no-fade="true" @ok="deleteTeam">
      <div>
        <p v-if="team">
          This will delete the team <b>permanently</b>. You'll delete too:
        </p>
        <ul v-if="team">
          <li>{{team.players.length}} Player(s)</li>
          <li>{{team.fixtureteams.length}} link(s) to Fixtures</li>
          <li>{{team.teamCompetitions.length}} link(s) to Competitions</li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>
<script>
import clone from 'clone'
import _ from 'lodash'
import { teamService } from '@/services/team'
import { sportService } from '@/services/sport'
import { positionService } from '@/services/position'
import { playerService } from '@/services/player'

export default {
  name: 'TeamShow',
  data () {
    return {
      team: null,
      playerEdition: null,
      playerDeletion: null,
      positions: null,
      sports: null,
      searchText: ''
    }
  },
  computed: {
    players () {
      if (this.searchText === '') return this.team.players
      else {
        let text = _.toLower(this.searchText)
        let exclude = null
        return _.filter(this.team.players, function (object) {
          return _(object).omit(exclude).some(function (string) {
            return _(string).toLower().includes(text)
          })
        })
      }
    }
  },
  mounted () {
    teamService.getOneGraph(this.$route.params.id).then(result => {
      this.team = result.data.team
    })
    sportService.getAll().then(result => {
      this.sports = result.data.sports
    })
    positionService.getAll().then(result => {
      this.positions = result.data.positions
    })
  },
  methods: {
    preparePlayerEdition (player) {
      let clonedPlayer = clone(player)
      this.playerEdition = {
        _id: clonedPlayer._id,
        first_name: clonedPlayer.first_name,
        last_name: clonedPlayer.last_name,
        usual_name: clonedPlayer.usual_name,
        previous_yellow_cards: clonedPlayer.previous_yellow_cards,
        number: clonedPlayer.number,
        sport: clonedPlayer.sport._id,
        position: clonedPlayer.position._id
      }
    },
    editPlayer (event) {
      playerService.updateOne(this.playerEdition).then(result => {
        this.team = null
        teamService.getOne(this.$route.params.id).then(result => {
          this.team = result.data.team
        })
      })
    },
    deletePlayer (event) {
      playerService.deleteOne(this.playerDeletion._id).then(result => {
        this.team = null
        teamService.getOne(this.$route.params.id).then(result => {
          this.team = result.data.team
        })
      })
    },
    deleteTeam (event) {
      teamService.deleteOne(this.$route.params.id, this.team.players.map(player => player._id), this.team.teamCompetitions.map(tc => tc._id), this.team.fixtureteams.map(ft => ft._id))
      this.$router.push({name: 'Teams'})
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-xs{
  font-size: 12px;
  padding: 4px 7px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Teams/TeamShow.vue